<script setup>
import {APP_STORE} from '~/utils/appLinks';
</script>

<script setup lang="ts">
</script>

<template>
  <div class="tl-card download-banner">
    <h2>Download the app today</h2>
    <p>
      Download the app today and you can start to manage your clubs on the go.
    </p>
    <div class="stores">
      <a :href="APP_STORE.ios" target="_blank">
        <img
            alt="Link to Apple App Store"
            src="/images/apple_link.png"
            width="150"
        />
      </a>
      <a :href="APP_STORE.android"
         target="_blank">
        <img
            alt="Link to Google Play Store"
            src="/images/google_link.png"
            width="160"
        />
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.download-banner {
  text-align: center;
  padding: 40px 24px;

  h2 {
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -0.5px;
  }

  p {
    font-size: 13px;
    color: rgb(var(--v-theme-charcoal));
    margin-top: 8px;
    line-height: 1.7;
  }

  .stores {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    flex-wrap: wrap;

    img {
      display: block;
      height: 44px;
      width: auto;
      border-radius: 8px;
    }
  }
}
</style>
